import { Flex, Stack, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { DocumentVersion } from 'src/suitability-report/hooks/useDocumentVersions';
import { formatVersionDate } from '../../utils/formatVersionDate';

type Props = {
  version: DocumentVersion;
  variant: 'saved' | 'removed';
};

export function FinaliseVersionCell({ version, variant }: Props) {
  const isSaved = variant === 'saved';

  return (
    <Flex
      p="xs"
      bg={isSaved ? 'success.0' : 'gray.0'}
      style={{
        borderRadius: 12,
        border: `1px solid var(--mantine-color-${isSaved ? 'success-6' : 'gray-2'})`,
      }}
    >
      <Stack gap={0}>
        <Text size="sm" fw={FONT_WEIGHTS.medium} c={isSaved ? 'gray.10' : 'gray.6'}>
          V{version.versionNumber}: {formatVersionDate(version.createdAt)}
        </Text>
        <Text size="xs" fw={FONT_WEIGHTS.medium} c="gray.6">
          Subtitle TODO
        </Text>
      </Stack>
    </Flex>
  );
}
